import { clsx } from 'clsx'
import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import css from './Indicator.module.scss'

type Props = {
  carousel: CarouselStore
  index: number
  white?: boolean
}

function size(distance: number) {
  if (distance === 0) return css.large
  if (distance === 1) return css.medium
  if (distance === 2) return css.small
  if (distance === 3) return css.mini
  return css.none
}

export const Indicator = observer(({ carousel, index, white }: Props) => {
  const distance = Math.abs(carousel.index - index)
  const className = clsx(css.indicator, size(distance), white && css.white)

  const onClick = useLatestCallback(() => carousel.index = index)

  return <div className={className} onClick={onClick}>
    <span className={css.dot} />
  </div>
})
